module.exports = __webpack_public_path__ + "img/demo7.75d432a6.jpg";